import React from "react";
import type { CurationNamedEntity } from "../../../utils/i18n/curationTranslations";

type Props = {
  entity: CurationNamedEntity;
  /** Resolved display name (already flag- and locale-aware). */
  displayName: string;
  className?: string;
};

/**
 * Renders a curation entity name. When the displayed (translated) name
 * differs from the canonical one, the canonical name is exposed as a tooltip
 * because server-side search still matches only the canonical name. Tooltip
 * only — no extra DOM/CSS, so flag on and off render an identical layout.
 */
export default function CurationEntityName({
  entity,
  displayName,
  className,
}: Props) {
  return (
    <span
      className={className}
      title={displayName !== entity.name ? entity.name : undefined}
    >
      {displayName}
    </span>
  );
}
